import React, { Component } from 'react';
import { connect } from 'react-redux';
import { adminUserActions } from 'redux/actions/admin-user-action';
import appBackgourndImg from "assets/img/zabin-logo.jpg";
import MessageCom from '../../layouts/Dashboard/Message';
import { Link } from 'react-router-dom';


class LoginPage extends Component {
    constructor(props) {
        super(props);
        var checkLogin = localStorage.getItem('user');
        if (checkLogin) {
            localStorage.removeItem('user');
            // this.props.dispatch(adminUserActions.logout());    
        }

        this.state = {
            user_name: '',
            password: '',
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { user_name, password } = this.state;
        const { dispatch } = this.props;
        if (user_name && password) {
            dispatch(adminUserActions.login(user_name, password));
        }
    }
    render() {
        const { user_name, password, submitted } = this.state;
        const { loggingIn } = this.props;
        return (
            <div className="main_login">
                <MessageCom />
                <p className="text-center logo_container mb-none"><Link to="/"><img className="img-responsive logoImageLogin" src={appBackgourndImg} alt="Logo" /> </Link> </p>
                <div className="login_form_container">
                    <div className="login_form">
                        <h1 className="text-center testrrr">Welcome Back!</h1>
                        <form name="form" onSubmit={this.handleSubmit}>
                            <div className={'form-group' + (submitted && !user_name ? ' has-error' : '')}>
                                <input type="user_name" placeholder="Enter Your Email..." className="form-control user_name_ctrl" name="user_name" value={user_name} onChange={this.handleChange} />
                                {submitted && !user_name &&
                                    <div className="help-block">User Name is required.</div>
                                }
                            </div>
                            <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                <input type="password" placeholder="Password" className="form-control password_ctrl" name="password" value={password} onChange={this.handleChange} />
                                {submitted && !password &&
                                    <div className="help-block">Password is required.</div>
                                }
                                <Link to='recover-account' style={{ color: 'blue' }}>Forgot your password?</Link>
                            </div>
                            <div className="form-group text-center">
                                <button className="customBtn btnBlue">LOGIN</button>
                                {loggingIn &&
                                    <img alt="imageLogin" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loggingIn } = state.adminReducer;
    return {
        loggingIn
    };
}

const Login = connect(mapStateToProps)(LoginPage);
export default Login;


// WEBPACK FOOTER //
// ./src/components/Admin/Login.jsx